import React from "react";
import fill from 'fill-range';
import styles from './InfoCard.module.scss';
import {Accordion, AccordionDetails, AccordionSummary} from '@material-ui/core';
import SkeletonPlaceHolder from 'gui/components/skeletonPlaceHolder';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import TopTitle from "./components/topTitle/TopTitle";

export interface IInfoCardSquare {
  children: any;
  style?: any;
  title: string | any;
  subTitleDetail: string | any;
  subTitleElement?: any;
  icon: any;
  toolTip: string;
  iconStyle: any;
  className?: any;
  ref?: any;
  defaultExpanded?: boolean;
  disabled?: boolean;
  loading?: boolean;

  iconContainerClassName?: string;
}


const InfoCard = (props: IInfoCardSquare) => (
  <Accordion ref={props.ref}
             className={`infoCardContainer ${styles.infoCardContainer} ${props.className} ${props.loading ? 'loading' : ''}`.trim()}
             component="section" elevation={0}
             style={{...props.style}}
             defaultExpanded={props.defaultExpanded}

  >
    <AccordionSummary
      expandIcon={<ExpandMoreIcon/>}
      aria-label="Expand"
      aria-controls="additional-actions1-content"
    >
      <TopTitle {...props}/>
    </AccordionSummary>
    <AccordionDetails>
      {props.loading ?
        fill(0, 10).map(i => <SkeletonPlaceHolder
          key={i}
          variant="text"
          height={25}/>)
        : props.children}
    </AccordionDetails>
  </Accordion>
);

InfoCard.defaultProps = {
  title: "",
  subTitleDetail: "",
  style: {},
  children: null,
  icon: null,
  toolTip: null,
  iconStyle: {},
  className: "",
  subTitleElement: null,
  defaultExpanded: window.innerWidth >= 768,
  disabled: window.innerWidth >= 768,
};

export default InfoCard;
